import React, { FC, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

export interface IAccordionOptions {
    title: string;
    subTitle?: string | undefined;
    isExpanded: boolean;
    isCollapsable: boolean;
    children;
    titleClass?: string;
    headerClass?: string;
    id?: string;
}

export const Accordion: FC<IAccordionOptions> = ({
    title,
    subTitle = null,
    isExpanded: initialExpanded = true,
    isCollapsable = true,
    children,
    titleClass = '',
    headerClass = '',
    id = '',
}) => {
    const [isExpanded, set_isExpanded] = useState(initialExpanded);

    useEffect(() => {
        if (!isCollapsable) set_isExpanded(true);
    }, [isCollapsable]);

    useEffect(() => {
        set_isExpanded(initialExpanded);
    }, [id]);

    useEffect(() => {
        set_isExpanded(initialExpanded);
    }, [initialExpanded]);

    return (
        <section
            id={id}
            className={`accordion-item ${isExpanded ? 'is-active' : ''}`}
            data-accordion-item=''
        >
            {isCollapsable && (
                // eslint-disable-next-line
                <>
                    <a
                        href='#'
                        onClick={() => set_isExpanded(!isExpanded)}
                        className={`accordion-title ${titleClass ?? ''}`}
                        style={headerClass === 'decorated' ? { top: '-5px' } : undefined}
                    >
                        <FontAwesomeIcon
                            className='accordian-icon'
                            icon={isExpanded ? faChevronUp : faChevronDown}
                            size='lg'
                        />
                    </a>
                </>
            )}
            <div
                className={`section-header`}
                onClick={() => set_isExpanded(!isExpanded)}
            >
                {title && (
                    <h2
                        className={headerClass}
                        style={{ width: '100%' }}
                    >
                        {title ?? ''}
                    </h2>
                )}
                {subTitle && <span style={{ fontSize: '14px', fontWeight: 'normal' }}>{subTitle ?? ''}</span>}
            </div>
            <div
                style={{
                    display: isExpanded || !isCollapsable ? 'block' : 'none',
                }}
            >
                <div
                    className='accordion-content'
                    style={{ display: 'block' }}
                >
                    {isExpanded && children}
                </div>
            </div>
        </section>
    );
};
